import PropTypes from "prop-types";
import * as React from "react";
import { View, Text, StyleSheet } from "react-native";
import { useWindowDimensions } from "react-native";
import statusFilter from "../utils/statusFilter";
import { isApplicationExpired } from "../utils/jobApplicationStatus";

const Chart = (props) => {
  const window = useWindowDimensions();
  const jobs = props?.jobs || [];
  const noJobs = jobs?.length === 0;

  let chartData;

  if (props.isNonLocum) {
    // For non-locum jobs, show only Applied and Expired
    const appliedJobs = jobs.filter((job) => [null, 0, 1].includes(job.job_application_status));
    const expiredJobs = jobs.filter((job) => isApplicationExpired(job));

    // Handle overlap: if a job is both applied and expired, only count it as expired
    const appliedNotExpired = appliedJobs.filter((job) => !isApplicationExpired(job));

    const appliedCount = noJobs ? 3 : appliedNotExpired.length;
    const expiredCount = noJobs ? 2 : expiredJobs.length;

    chartData = [
      { label: "Applied", value: appliedCount, color: noJobs ? "#e8e8e8" : "#59C2FF" },
      { label: "Expired", value: expiredCount, color: noJobs ? "#e8e8e8" : "#808080" },
    ];
  } else {
    // Original logic for locum jobs
    const status = {
      pending: noJobs
        ? 5
        : jobs.filter((val) => {
          return statusFilter("pending", val);
        }).length,
      cancelled: noJobs
        ? 2
        : jobs.filter((val) => {
          return statusFilter("cancelled", val, props.isDoctor);
        }).length,
      approved: noJobs
        ? 4
        : jobs.filter((val) => {
          return statusFilter("approved", val, props.isDoctor);
        }).length,
      completed: noJobs
        ? 3
        : jobs.filter((val) => {
          return statusFilter("completed", val);
        }).length,
    };

    chartData = [
      { label: "Cancelled", value: status.cancelled, color: noJobs ? "#e8e8e8" : "#FC6767" },
      { label: "Pending", value: status.pending, color: noJobs ? "#e8e8e8" : "#FFB454" },
      { label: "Approved", value: status.approved, color: noJobs ? "#e8e8e8" : "#59C2FF" },
      { label: "Completed", value: status.completed, color: noJobs ? "#e8e8e8" : "#AAD94C" },
    ];
  }

  // Calculate max value for scaling
  const maxValue = Math.max(...chartData.map(item => item.value), 1);
  const chartHeight = 100;
  const barWidth = window.width / (chartData.length * 2);

  return (
    <View style={styles.container}>
      <View style={styles.chartContainer}>
        <View style={styles.barsContainer}>
          {chartData.map((item, index) => {
            const barHeight = (item.value / maxValue) * chartHeight;
            return (
              <View key={index} style={styles.barWrapper}>
                <View style={styles.barColumn}>
                  <View style={[styles.barBackground, { height: chartHeight }]}>
                    <View
                      style={[
                        styles.bar,
                        {
                          height: barHeight,
                          backgroundColor: item.color,
                          width: barWidth,
                        },
                      ]}
                    />
                  </View>
                  <Text style={[styles.label, { marginVertical: 12, color: 'rgba(0, 0, 0, 0.6)' }]}>
                    {item.label}
                  </Text>
                </View>
              </View>
            );
          })}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    paddingVertical: 10,
  },
  chartContainer: {
    width: "100%",
    alignItems: "center",
  },
  barsContainer: {
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "space-around",
    width: "100%",
    paddingHorizontal: 0,
  },
  barWrapper: {
    alignItems: "center",
    flex: 1,
  },
  barColumn: {
    alignItems: "center",
    justifyContent: "flex-end",
  },
  barBackground: {
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  bar: {
    borderRadius: 4,
    width: "80%",
  },
  label: {
    marginTop: 8,
    fontSize: 12,
    fontWeight: "600",
    textAlign: "center",
  },
  cardStyle: {
    paddingBottom: 0,
  },
});

Chart.propTypes = {
  jobs: PropTypes.array,
  isNonLocum: PropTypes.bool,
  isDoctor: PropTypes.bool,
  style: PropTypes.object,
};

export default Chart;
